export const EOSP_REPORT_FIELDS = {
    tab1: {
        'Report Details': [
            {
                reportName: 'EOSP',
                tab: 1,
                groupName: 'Report Details',
                label: 'Date and Time of Report (UTC)',
                fieldName: 'report_create_time', // report_create_time
                required: false,
                type: 'date',
                editable: 'editable',
            },
            {
                reportName: 'EOSP',
                tab: 1,
                groupName: 'Report Details',
                label: 'Departure Voyage Number',
                fieldName: 'voyage_num', // voyage_num
                required: true,
                type: 'number',
                editable: 'readOnly',
            },
        ],
           
        Arrival: [
            {
                reportName: 'EOSP',
                tab: 2,
                groupName: 'Arrival',
                label: 'Arrival Port Code',
                fieldName: 'arr_port_code_voyage', // arr_port_code
                required: true,
                type: 'dropdown',
                editable: 'readOnly',
            },
            {
                reportName: 'EOSP',
                tab: 1,
                groupName: 'Arrival',
                label: 'Latitude',
                fieldName: 'lat', // lat
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'EOSP',
                tab: 1,
                groupName: 'Arrival',
                label: 'Longitude',
                fieldName: 'lon', // lon
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'EOSP',
                tab: 1,
                groupName: 'Arrival',
                label: 'Course',
                fieldName: 'course', // course
                required: false,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'EOSP',
                tab: 2,
                groupName: 'Arrival',
                label: 'Time Since Last Report',
                fieldName: 'arr_eosp_steaming_hours', // arr_eosp_steaming_hours
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'EOSP',
                tab: 2,
                groupName: 'Arrival',
                label: 'Distance Sailed Since Last Report',
                fieldName: 'arr_eosp_steaming_distance', // arr_eosp_steaming_distance
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'EOSP',
                tab: 2,
                groupName: 'Arrival',
                label: 'Average Speed Since Last Report',
                fieldName: 'arr_eosp_average_speed', // arr_eosp_average_speed
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'EOSP',
                tab: 2,
                groupName: 'Arrival',
                label: 'Average RPM Since Last Report',
                fieldName: 'arr_eosp_average_rpm', // arr_eosp_average_rpm
                required: false,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'EOSP',
                tab: 1,
                groupName: 'Arrival',
                label: 'Loading Condition',
                fieldName: 'loading_condition', // loading_condition
                required: true,
                type: 'dropdown',
                editable: 'editable',
            },
        ],
        Weather: [
            {
                reportName: 'EOSP',
                tab: 2,
                groupName: 'Weather',
                label: 'True Wave Direction',
                fieldName: 'windsea_dir', // windsea_dir
                required: false,
                type: 'dropdown',
                editable: 'editable',
            },
            {
                reportName: 'EOSP',
                tab: 2,
                groupName: 'Weather',
                label: 'Wave height',
                fieldName: 'windsea_height', // windsea_height
                required: false,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'EOSP',
                tab: 2,
                groupName: 'Weather',
                label: 'True Swell Direction',
                fieldName: 'swell_dir', // swell_dir
                required: false,
                type: 'dropdown',
                editable: 'editable',
            },
            {
                reportName: 'EOSP',
                tab: 2,
                groupName: 'Weather',
                label: 'Swell Height',
                fieldName: 'swell_height', // swell_height
                required: false,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'EOSP',
                tab: 2,
                groupName: 'Weather',
                label: 'Visibility',
                fieldName: 'visibility', // visibility
                required: false,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'EOSP',
                tab: 2,
                groupName: 'Weather',
                label: 'True Wind Direction',
                fieldName: 'wind_dir', // wind_dir
                required: false,
                type: 'dropdown',
                editable: 'editable',
            },
            {
                reportName: 'EOSP',
                tab: 2,
                groupName: 'Weather',
                label: 'True Wind Speed',
                fieldName: 'wind_speed', // wind_speed
                required: false,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'EOSP',
                tab: 2,
                groupName: 'Weather',
                label: 'Wind Beaufort',
                fieldName: 'wind_bf', // wind_bf
                required: false,
                type: 'number',
                editable: 'readOnly',
            },
        ],
        Distance: [
            {
                reportName: 'EOSP',
                tab: 2,
                groupName: 'Distance',
                label: 'Total Distance Sailed Pilot to Pilot',
                fieldName: 'sosp_eosp_total_distance', // sosp_eosp_total_distance
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'EOSP',
                tab: 2,
                groupName: 'Distance',
                label: 'Total Time Pilot to Pilot',
                fieldName: 'sosp_eosp_total_hours',// sosp_eosp_total_hours
                required: true,
                type: 'number',
                editable: 'editable',
            },
        ],
        Comment: [
            {
                reportName: 'EOSP',
                tab: 2,
                groupName: 'Comment',
                label: 'Comment',
                fieldName: 'remarks', // remarks
                required: false,
                type: 'string',
                editable: 'editable',
            },
        ],
    },
}

export const SOSP_REPORT_FIELDS = {
    tab1: {
        'Report Details': [
            {
                reportName: 'SOSP',
                tab: 1,
                groupName: 'Report Details',
                label: 'Date and Time of Report (UTC)',
                fieldName:  'report_create_time', // report_create_time
                required: false,
                type: 'date',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 1,
                groupName: 'Report Details',
                label: 'Departure Voyage Number',
                fieldName:'voyage_num', // voyage_num
                required: true,
                type: 'number',
                editable: 'readOnly',
            },
        ],
        Departure: [
            {
                reportName: 'SOSP',
                tab: 1,
                groupName: 'Departure',
                label: 'Latitude',
                fieldName:  'lat', // lat
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 1,
                groupName: 'Departure',
                label: 'Longitude',
                fieldName: 'lon', // lon
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 1,
                groupName: 'Departure',
                label: 'Course',
                fieldName: 'course', // course
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 1,
                groupName: 'Departure',
                label: 'Departure Port Code',
                fieldName: 'dep_port_code_voyage',
                required: true,
                type: 'dropdown',
                editable: 'readOnly',
            },
            {
                reportName: 'SOSP',
                tab: 2,
                groupName: 'Departure',
                label: 'Draft Fore',
                fieldName: 'dep_berth_draft_fore',
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 2,
                groupName: 'Departure',
                label: 'Draft Aft',
                fieldName: 'dep_berth_draft_aft',
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 2,
                groupName: 'Departure',
                label: 'Solid GM',
                fieldName: 'solid_gm',
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 2,
                groupName: 'Departure',
                label: 'RPM',
                fieldName: 'dep_sosp_rpm',
                required: false,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 3,
                groupName: 'Departure',
                label: 'Loading Condition',
                fieldName: 'loading_condition', // loading_condition
                required: true,
                type: 'dropdown',
                editable: 'editable',
            },
        ],
        Arrival: [
            {
                reportName: 'SOSP',
                tab: 1,
                groupName: 'Arrival',
                label: 'Arrival Port Code',
                fieldName:'arr_port_code_voyage', // arr_port_code
                required: true,
                type: 'dropdown',
                editable: 'readOnly',
            },
            {
                reportName: 'SOSP',
                tab: 2,
                groupName: 'Arrival',
                label: 'ETA Pilot Station (LT)',
                fieldName: 'arr_ps_master_eta_lt',
                required: false,
                type: 'date',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 2,
                groupName: 'Arrival',
                label: 'ETA Berth (LT)',
                fieldName: 'arr_ps_scheduled_eta',
                required: true,
                type: 'date',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 1,
                groupName: 'Arrival',
                label: 'ETA Margin',
                fieldName: 'arr_ps_requested_eta_margin',
                required: false,
                type: 'string',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 2,
                groupName: 'Arrival',
                label: 'Arrival Pilot Position Latitude',
                fieldName: 'arr_ps_lat',
                required: false,
                type: 'number',
                editable: 'readOnly',
            },
            {
                reportName: 'SOSP',
                tab: 2,
                groupName: 'Arrival',
                label: 'Arrival Pilot Position Longitide',
                fieldName: 'arr_ps_lon',
                required: false,
                type: 'number',
                editable: 'readOnly',
            },
        ],
        Weather: [
            {
                reportName: 'SOSP',
                tab: 1,
                groupName: 'Weather',
                label: 'True Wave Direction',
                fieldName: 'windsea_dir', // windsea_dir
                required: false,
                type: 'dropdown',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 1,
                groupName: 'Weather',
                label: 'Wave height',
                fieldName: 'windsea_height', // windsea_height
                required: false,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 3,
                groupName: 'Weather',
                label: 'True Swell Direction',
                fieldName: 'swell_dir', // swell_dir
                required: false,
                type: 'dropdown',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 3,
                groupName: 'Weather',
                label: 'Swell Height',
                fieldName: 'swell_height', // swell_height
                required: false,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 3,
                groupName: 'Weather',
                label: 'Visibility',
                fieldName: 'visibility', // visibility
                required: false,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 2,
                groupName: 'Weather',
                label: 'True Wind Direction',
                fieldName: 'wind_dir', // wind_dir
                required: false,
                type: 'dropdown',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 2,
                groupName: 'Weather',
                label: 'True Wind Speed',
                fieldName: 'wind_speed', // wind_speed
                required: false,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'SOSP',
                tab: 2,
                groupName: 'Weather',
                label: 'Wind Beaufort',
                fieldName: 'wind_bf', // wind_bf
                required: false,
                type: 'number',
                editable: 'readOnly',
            },
        ],
        Comment: [

            {
                reportName: 'SOSP',
                tab: 2,
                groupName: 'Remarks',
                label: 'Comments',
                fieldName: 'remarks', // remarks
                required: false,
                type: 'string',
                editable: 'editable',
            },
        ],
    },
}


export const NOON_REPORT_FIELDS = {
    tab1: {
        'Report Details': [
            {
                reportName: 'NOON',
                tab: 1,
                groupName: 'Report Details',
                label: 'Date and Time of Report (UTC)',
                fieldName: 'report_create_time', // report_create_time
                required: false,
                type: 'date',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 1,
                groupName: 'Report Details',
                label: 'Departure Voyage Number',
                fieldName: 'voyage_num', // voyage_num
                required: true,
                type: 'number',
                editable: 'readOnly',
            },
        ],
        Noon: [
            {
                reportName: 'NOON',
                tab: 1,
                groupName: 'Noon',
                label: 'Loading Condition',
                fieldName: 'loading_condition', // loading_condition
                required: true,
                type: 'dropdown',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 1,
                groupName: 'Noon',
                label: 'Latitude',
                fieldName: 'lat', // lat
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 1,
                groupName: 'Noon',
                label: 'Longitude',
                fieldName: 'lon', // lon
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 1,
                groupName: 'Noon',
                label: 'Course',
                fieldName: 'course',
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Noon',
                label: 'Draft Aft',
                fieldName: 'noon_draft_aft',
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Noon',
                label: 'Draft Fore',
                fieldName: 'noon_draft_fore',
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Noon',
                label: 'Solid GM',
                fieldName: 'solid_gm',
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Noon',
                label: 'Average SoG Since Last Report',
                fieldName: 'nton_average_speed',
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Noon',
                label: 'Average RPM Since Last Report',
                fieldName: 'nton_average_rpm',
                required: false,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Noon',
                label: 'RPM',
                fieldName: 'rpm',
                required: false,
                type: 'number',
                editable: 'editable',
            },
        ],
        Arrival: [
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Arrival',
                label: 'Arrival Port Code',
                fieldName: 'arr_port_code_voyage', // arr_port_code
                required: true,
                type: 'dropdown',
                editable: 'readOnly',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Arrival',
                label: 'ETA Pilot Station (LT)',
                fieldName: 'arr_ps_master_eta_lt',
                required: false,
                type: 'date',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Arrival',
                label: 'ETA Berth (LT)',
                fieldName: 'arr_ps_scheduled_eta',
                required: true,
                type: 'date',
                editable: 'editable',
            },
        ],
        Weather: [
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Weather',
                label: 'True Wave Direction',
                fieldName: 'windsea_dir', // windsea_dir
                required: false,
                type: 'dropdown',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Weather',
                label: 'Wave height',
                fieldName: 'windsea_height', // windsea_height
                required: false,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Weather',
                label: 'True Swell Direction',
                fieldName: 'swell_dir', // swell_dir
                required: false,
                type: 'dropdown',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Weather',
                label: 'Swell Height',
                fieldName: 'swell_height', // swell_height
                required: false,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Weather',
                label: 'Visibility',
                fieldName: 'visibility', // visibility
                required: false,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Weather',
                label: 'True Wind Direction',
                fieldName: 'wind_dir', // wind_dir
                required: false,
                type: 'dropdown',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Weather',
                label: 'True Wind Speed',
                fieldName: 'wind_speed', // wind_speed
                required: false,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Weather',
                label: 'Wind Beaufort',
                fieldName: 'wind_bf', // wind_bf
                required: false,
                type: 'number',
                editable: 'readOnly',
            },
        ],
        Distance: [
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Steaming',
                label: 'Time since last report',
                fieldName: 'steaming_hours',
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Steaming',
                label: 'Distance Sailed Since Last Report',
                fieldName: 'steaming_distance',
                required: true,
                type: 'number',
                editable: 'editable',
            },
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Steaming',
                label: 'Remaining distance to Pilot Station',
                fieldName: 'remaining_distance_to_ps',
                required: true,
                type: 'number',
                editable: 'editable',
            },
        ],
        Comment: [
            {
                reportName: 'NOON',
                tab: 2,
                groupName: 'Comment',
                label: 'Comment',
                fieldName: 'remarks', // remarks
                required: false,
                type: 'string',
                editable: 'editable',
            },
        ],
    },
}